import styles from './HeaderGuest.module.scss';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { PATHS } from 'Libraries/routes.library';
import { useStrapiTitles } from 'Hooks/strapi-titles';
import { ETitles, RegTypes } from 'Types/globals';
import { useDispatch } from 'react-redux';
import { useRegType } from 'Hooks/useRegType';
import { OVERLAY_ALL_CLOSE, OVERLAY_LOGIN_SHOW, OVERLAY_PAYNPLAY_LOGIN_SHOW } from '@spinwise/spinwise-core';
import { getOverlaySearch } from 'Components/_brand/overlays/brandOverlaysLibrary';
import dynamic from 'next/dynamic';
import { IconSearch } from '@spinwise/react-component-library/IconSearch';
import useShowAuthButtons from 'Hooks/useShowAuthButtons';
const HeaderBasic = dynamic(() => import('../Basic/HeaderBasic'), { ssr: false });

const HeaderGuest = () => {
  const dispatch = useDispatch();
  const isRegType = useRegType();
  const router = useRouter();
  
  const showAuthButtons = useShowAuthButtons();

  const [strapiLoginBtn, strapiRegisterBtn] = useStrapiTitles([ETitles.LOGIN_BTN_TEXT, ETitles.REGISTER_BTN_TEXT]);

  const handleClickLogin = () => {
    dispatch({
      type: OVERLAY_ALL_CLOSE,
      data: true,
    });
    dispatch({
      type: isRegType([RegTypes.PAYPLAY_T, RegTypes.PAYPLAY_Z]) ? OVERLAY_PAYNPLAY_LOGIN_SHOW : OVERLAY_LOGIN_SHOW,
      data: true,
    });
  };

  return (
    <HeaderBasic>
      <div className={styles.action_wrapper}>
        {router?.pathname != PATHS.GAMES ? (
          <div
            className={styles.custom_small_search_wrapper}
            onClick={() => {
              getOverlaySearch();
            }}
          >
            <IconSearch size={24} customClass={styles.custom_small_search} />
          </div>
        ) : null}
        
        {showAuthButtons ? 
          <>
            <button
              className={classNames('Button ActionButton ActionButton--login', styles.button, styles.button_login)}
              onClick={handleClickLogin}
              data-qa="button-header-login"
            >
              <p>{strapiLoginBtn ?? '\u00A0'}</p>
            </button>

            <button
              className={classNames('Button ActionButton ActionButton--register', styles.button)}
              onClick={() => {
                router.push(PATHS.REGISTER);
              }}
              data-qa="button-header-register"
            >
              <p>{strapiRegisterBtn ?? '\u00A0'}</p>
            </button>
          </>
        : null}
      </div>
    </HeaderBasic>
  );
};
export default HeaderGuest;
